import { render } from "../../templates/scenarios.html?vue&type=template&id=924b4532&scoped=true"
import script from "./scenarios.vue?vue&type=script&lang=js"
export * from "./scenarios.vue?vue&type=script&lang=js"

import "./scenarios.vue?vue&type=style&index=0&id=924b4532&scoped=true&lang=scss"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924b4532"]])

export default __exports__